import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ChangePassword } from 'src/app/core/models';
import { AuthenticationService, UINotificationService } from 'src/app/core/services';
import { passwordValidator } from 'src/app/theme/utils/app-validators';

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.scss'],
})
export class ChangePasswordDialogComponent implements OnInit {
  form: FormGroup;
  saving: boolean;
  newPasswordHide = true;
  oldPasswordHide = true;

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public model: ChangePassword,
    public fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private translateService: TranslateService,
    private notificationService: UINotificationService
  ) {
    this.form = this.fb.group({
      oldPassword: [null, Validators.compose([Validators.required])],
      newPassword: [
        null,
        Validators.compose([Validators.required, Validators.minLength(5), passwordValidator]),
      ],
    });
  }

  ngOnInit() {}

  close(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    this.saving = true;

    this.authenticationService
      .chnagePassword(this.form.value)
      .pipe(finalize(() => (this.saving = false)))
      .subscribe(res => {
        if (res) {
          this.notificationService.showSimpleSnack('success', false);
          this.dialogRef.close(true);
        } else {
          const message = this.translateService.instant('CHANGE_PASSWORD.INVALID_PASSWORD');
          this.notificationService.showSimpleSnack(message, true);
        }
      });
  }
}
